import { z } from "zod";

export const upsertStoreShippingConfigurationSchema = z.object({
  shippingFee: z.number().min(0),
  freeShippingMinQuantity: z.number().int().positive().nullable().optional(),
  currency: z.string().trim().length(3).optional(),
  shippingNote: z.string().trim().max(2000).optional(),
  supportsPickup: z.boolean().optional(),
  supportsDelivery: z.boolean().optional(),
});
export type UpsertStoreShippingConfigurationInput = z.infer<
  typeof upsertStoreShippingConfigurationSchema
>;
